import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

function TypingEffect({ text, delay = 50, speedFactor = 2, setIsTyping }) {
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    let index = 0;
    const words = text ? [...text.split(" ")] : [];
    const intervalId = setInterval(() => {
      if (index < words.length) {
        index += speedFactor;
        setDisplayedText(words.slice(0, index).join(" "));
      } else {
        clearInterval(intervalId);
        setIsTyping(false);
      }
    }, delay);

    return () => clearInterval(intervalId);
  }, [text, delay, speedFactor, setIsTyping]);

  return <ReactMarkdown>{displayedText}</ReactMarkdown>;
}

export default TypingEffect;